import React, {useEffect, useState} from "react"; //React,
import {Captcha1} from "./Captchas/Captcha1";
import {Popup} from "./Popup";
import {Captcha2} from "./Captchas/Captcha2";
import {Captcha3} from "./Captchas/Captcha3";
import { TextCaptcha1 } from "./Captchas/TextCaptcha1";
import { TextCaptcha2 } from "./Captchas/TextCaptcha2";
import { TextCaptcha3 } from "./Captchas/TextCaptcha3";
import {Captcha4} from "./Captchas/Captcha4";
import {AdCaptcha} from "./Captchas/AdCaptcha";

const song1 = new Audio("/song1.mp3");
const song2 = new Audio("/audio/tank_engine.mp3")
const song3 = new Audio("/audio/sad_violin.mp3")

interface CaptchaProps {
    completed: boolean;
    setCompleted: (skip: boolean) => any;
}
export function Captcha(props: CaptchaProps) {

    const [rotate, setRotate] = useState(false);
    const [skip, setSkip] = useState(true);
    const [infoPopup, setInfoPopup] = useState(false);
    //const [audio] = useState(new Audio("src/sounds/music.mp3"));
    const [playing, setPlaying] = useState(false);
    const [loading, setLoading] = useState(false);

    //timer variable
    const [seconds, setSeconds] = React.useState(10);//10 second nasty ad :)
    const interval = React.useRef<ReturnType<typeof setInterval>>();
    const [buttonBlocked, setButtonBlocked] = useState(false);

    const [captchaNr, setCaptchaNr] = useState(1);

    var captchaDescriptions = [
        {
            captchaNr: 1,
            top: "Select all pictures with",
            mid: "traffic lights",
            bottom: "If there are none, click skip"
        },
        {
            captchaNr: 2,
            top: "",
            mid: "Match the characters in the picture",
            bottom: ""
        },
        {
            captchaNr: 3,
            top: "Select all pictures with",
            mid: "flag poles",
            bottom: "If there are none, click skip"
        },
        {
            captchaNr: 4,
            top: "",
            mid: "Match the characters in the picture",
            bottom: ""
        },
        {
            captchaNr: 5,
            top: "",
            mid: "Sponsors",
            bottom: ""
        },
        {
            captchaNr: 6,
            top: "Select all pictures with",
            mid: "fire hydrants",
            bottom: "If there are none, click skip"
        },
        {
            captchaNr: 7,
            top: "Select all pictures with",
            mid: "humans",
            bottom: "If there are none, click skip"
        },
        {
            captchaNr: 8,
            top: "",
            mid: "Match the characters in the picture",
            bottom: ""
        }
    ];

    const [completed, setCompleted] = useState(false);

    //const audio = new Audio("https://audio.bfmtv.com/bfmbusiness_128.mp3?aw_0_1st.playerId=AudioPlayer_Web_Next");

    useEffect(()=> {
        playing ? song3.play(): song3.pause();
    }, [playing])

    useEffect(() => {
        props.setCompleted(completed);
    },[completed]);

    function handleClick(){
        setLoading(true);
        setTimeout(function() {
            setCaptchaNr(captchaNr + 1);
            if(captchaNr === 8) {
                setCompleted(true);
            }
            setLoading(false);
        }, 1500);
    }

    function startTimer(){
        interval.current = setInterval(
            () => setSeconds((prevTimer) => prevTimer - 1),
            1000
        );
    }

    if (seconds === -3) {
        clearInterval(Number(interval.current));
        setSeconds(0);
        setButtonBlocked(false);
    }

    useEffect(()=>{
        if (captchaNr == 5){
            startTimer();
            setButtonBlocked(true)
        }
    },[captchaNr])

    return (
        <div>
            <Popup
                popupOpen={infoPopup}
                setPopupOpen={setInfoPopup}
            />

            <div className={"captcha"}>
                <div className={"blueBox"}>
                    {captchaDescriptions.map((descriptions) =>
                        <div>
                            {captchaNr == descriptions.captchaNr && !loading
                                ? <div>
                                    <h3>{descriptions.top}</h3>
                                    <h1>{descriptions.mid}</h1>
                                    <h3>{descriptions.bottom}</h3>
                                </div>
                                : null
                            }
                        </div>
                    )}

                </div>
                <div className={rotate == true ? "rotate image" : "image"}>
                    {loading &&
                        <div className="loading-container">
                            <div className="loading loading--full-height"></div>
                        </div>
                    }

                    {captchaNr == 1 && !loading &&
                        <Captcha1
                        skip={skip}
                        setSkip={setSkip}
                        />
                    }

                    {captchaNr == 2 && !loading &&
                        <TextCaptcha2
                            skip={skip}
                            setSkip={setSkip}
                        />
                    }

                    {captchaNr == 3 && !loading &&
                        <Captcha2
                            skip={skip}
                            setSkip={setSkip}
                        />
                    }
                    {captchaNr == 4 && !loading &&
                        <TextCaptcha3
                            skip={skip}
                            setSkip={setSkip}
                        />
                    }
                    {captchaNr == 5 && !loading &&
                        <AdCaptcha
                            skip={skip}
                            setSkip={setSkip}
                        />
                    }
                    {captchaNr == 6 && !loading &&
                        <Captcha4
                            skip={skip}
                            setSkip={setSkip}
                        />
                    }
                    {captchaNr == 7 && !loading &&
                        <Captcha3
                            skip={skip}
                            setSkip={setSkip}
                        />
                    }
                    {captchaNr == 8 && !loading &&
                        <TextCaptcha1
                            skip={skip}
                            setSkip={setSkip}
                        />
                    }
                </div>

                <div className={"buttonsDiv"}>
                    <div className={"iconsDiv"}>
                        <div className={"refreshButton"} onClick={e => setRotate(!rotate)}>

                        </div>

                        <div className={"headphonesButton"}
                             onClick={e => {setPlaying(!playing)}}>
                            <audio id="myAudio">
                                <source src="./song1.wav" type="audio/wav"/>
                            </audio>
                        </div>

                        <div
                            className={"infoDiv"}
                            onClick={e => {setInfoPopup(true)}}>
                            &#9432;
                        </div>

                    </div>
                    <div className={"verifyDiv"}>
                        <button
                            type="button"
                            className={"verifyButton"}
                            onClick={handleClick}
                            //disabled={!(seconds === -2)}
                            disabled={buttonBlocked || (captchaNr === 8 && skip)}
                        >
                            {!buttonBlocked ? (skip ? (captchaNr === 8 ? "" : "SKIP") : "VERIFY") : seconds}</button>
                    </div>
                </div>
            </div>
        </div>

    )

}
export default Captcha;
